import React from 'react';
import { TapformLogoIcon } from '../../assets/images/icons';
import styles from './index.module.scss';

export interface WatermarkProps {
  className?: string;
}

function MobileWatermark({ className = '' }: WatermarkProps) {
  return (
    <div
      className={`${styles.container} ${className}`}
      onClick={() =>
        window.open('https://tapform.com?utm_source=watermark', '_blank')
      }
    >
      <TapformLogoIcon type="white" className={styles.logo} />
      <span className={styles.label}>Made using Tapform</span>
    </div>
  );
}

export default MobileWatermark;
